import { Route } from '@common/types/Route';
import { Ns } from '@web/i18n/types';

export const NamespacesByRoute: Record<Route, string[]> = {
    // Routes matching the Route enum
    [Route.Homepage]: [Ns.Videos],
    [Route.Search]: [Ns.Search],
    [Route.Comments]: [Ns.Comments, Ns.PostComment],
    [Route.VideoPlayer]: [Ns.Videos],

    // Routes matching '/livescores'
    [Route.Match]: [Ns.Livescores],
    [Route.MatchInfo]: [Ns.Livescores],
    [Route.MatchByID]: [Ns.Livescores],
    [Route.MatchNews]: [Ns.Livescores],
    [Route.MatchOverviewDay]: [Ns.Livescores],
    [Route.MatchOverview]: [Ns.Livescores],
    [Route.MatchSetup]: [Ns.Livescores],
    [Route.MatchStats]: [Ns.Livescores],
    [Route.MatchSummary]: [Ns.Livescores],
    [Route.MatchPrediction]: [Ns.Stats, Ns.Livescores],

    // Routes matching '/competitions'
    [Route.CompetitionOverview]: [Ns.Livescores, Ns.Competitions],
    [Route.Competition]: [Ns.Livescores, Ns.Competitions],
    [Route.CompetitionTabOrSeason]: [Ns.Livescores, Ns.Competitions],

    // Routes matching '/clubs'
    [Route.Club]: [Ns.Livescores],
    [Route.ClubOverview]: [Ns.Livescores],

    // Routes matching '/news'
    [Route.Advertorial]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Livescores, Ns.Videos],
    [Route.AdvertorialArticle]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Livescores, Ns.Videos],
    [Route.Article]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Livescores, Ns.Videos],
    [Route.PremiumArticle]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Livescores, Ns.Videos],
    [Route.ArticlePreview]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Livescores, Ns.Videos],
    [Route.TransferNews]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Livescores, Ns.Videos],
    [Route.CategoryNews]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Livescores, Ns.Videos],
    [Route.Podcast]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Livescores, Ns.Videos],
    [Route.BrightPodcast]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Livescores, Ns.Videos],
    [Route.RecentNews]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Livescores, Ns.Videos],
    [Route.News]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Livescores, Ns.Videos],

    // Routes matching '/videos'
    [Route.VideosArticle]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Videos],
    [Route.VideosArticlePreview]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Videos],
    [Route.VideoArticle]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Videos],
    [Route.VideoCategory]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Videos],
    [Route.VideoOverview]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Videos],
    [Route.AudioArticle]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Videos],

    // Routes matching '/profile'
    [Route.Profile]: [Ns.Profile],
    [Route.Settings]: [Ns.Profile],
    [Route.Notifications]: [Ns.Profile],
    [Route.MySubscription]: [Ns.Profile],
    [Route.MyPxr]: [Ns.Profile],
    [Route.Bookmarks]: [Ns.Profile],
    [Route.Posts]: [Ns.Profile],

    //Routes matching '/players'
    [Route.Player]: [],
    [Route.PlayerInfo]: [],
    [Route.PlayerCareer]: [],
    [Route.PlayerNews]: [],

    // Routes matching '/subscribe'
    [Route.Subscribe]: [Ns.Subscribe],
    [Route.SubscribeSwitch]: [Ns.Subscribe],
    [Route.SubscribeSuccess]: [Ns.Subscribe],
    [Route.SubscribeFailure]: [Ns.Subscribe],

    // Routes matching '/secure'
    [Route.VerifyEmail]: [Ns.Secure],
    [Route.Signin]: [Ns.Secure],
    [Route.PasswordReset]: [Ns.Secure],
    [Route.AttemptRefresh]: [Ns.Secure],
    [Route.Signout]: [Ns.Secure],

    // Routes for author/user page
    [Route.Author]: [Ns.User, Ns.Author],
    [Route.User]: [Ns.User, Ns.Author],

    [Route.ForumPost]: [Ns.Articles, Ns.Comments, Ns.PostComment],
    [Route.CreatePost]: [Ns.CreatePost],
    [Route.CreatePostSuccess]: [Ns.CreatePost],
    [Route.ForumOverview]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Search],

    // Routes matching '/names'
    [Route.NameOriginAndGenderCategory]: [],
    [Route.NameCategoryOrDetail]: [],
    [Route.NameOverview]: [],
    [Route.NameSearch]: [],

    [Route.AdsTxt]: [],
    [Route.Betting]: [],
    [Route.BrandOverview]: [],
    [Route.BrightAi]: [],
    [Route.Browserconfig]: [],
    [Route.CarOverview]: [],
    [Route.Car]: [],
    [Route.Contact]: [Ns.Contact],
    [Route.ContentSection]: [],
    [Route.CyclingCompetition]: [],
    [Route.CyclingCompetitionOverview]: [],
    [Route.DossierOverview]: [],
    [Route.Dossier]: [],
    [Route.Error]: [],
    [Route.EventOverview]: [],
    [Route.Event]: [],
    [Route.FeedMedia]: [],
    [Route.FeedNews]: [],
    [Route.ForgotPassword]: [],
    [Route.GoogleNewsSitemap]: [],
    [Route.LicensePlate]: [],
    [Route.Liveness]: [],
    [Route.LocationOverview]: [],
    [Route.Location]: [],
    [Route.Manifest]: [],
    [Route.MySquad]: [],
    [Route.AuthorSitemap]: [],
    [Route.MatchesSitemap]: [],
    [Route.NavigationSitemap]: [],
    [Route.OneSignalSDKWorker]: [],
    [Route.OrganizationOverview]: [],
    [Route.Organization]: [],
    [Route.Page]: [],
    [Route.PersonOverview]: [],
    [Route.Person]: [],
    [Route.PlayerOverview]: [],
    [Route.PlayerRating]: [Ns.PlayerRating],
    [Route.Premium]: [],
    [Route.BrightPlusPlus]: [],
    [Route.Preview]: [Ns.Videos, Ns.Subscribe],
    [Route.Readiness]: [],
    [Route.Robots]: [],
    [Route.RssFeedOverview]: [],
    [Route.SegmentedQuarterNewsSitemap]: [],
    [Route.SegmentedTagSitemap]: [],
    [Route.SegmentedVideosSitemap]: [],
    [Route.SegmentedWeekNewsSitemap]: [],
    [Route.SitemapIndex]: [],
    [Route.Spot]: [Ns.Articles, Ns.Comments, Ns.PostComment, Ns.Videos],
    [Route.Spots]: [Ns.Articles, Ns.Comments],
    [Route.TestClientError]: [],
    [Route.TestServerError]: [],
    [Route.TagSitemap]: [],
    [Route.TopicOverview]: [],
    [Route.Topic]: [],
    [Route.TransferRumors]: [],
    [Route.UploadSpots]: [Ns.UploadSpots],
    [Route.UploadSpotsSuccess]: [Ns.UploadSpots],
    [Route.UserMatchPredictionsCompetition]: [Ns.Livescores, Ns.Competitions, Ns.Stats],
    [Route.UserMatchPredictionsCompetitionSeason]: [Ns.Livescores, Ns.Competitions, Ns.Stats],
    [Route.UserMatchPredictionsCompetitionSeasonDate]: [Ns.Livescores, Ns.Competitions, Ns.Stats],
    [Route.UserMatchPredictionsCompetitionScoreboard]: [Ns.Livescores, Ns.Competitions],
    [Route.UserMatchPredictionsScoreboard]: [Ns.Livescores, Ns.Competitions],
    [Route.WellKnownAndroid]: [],
    [Route.WellKnownIOS]: [],
};
